var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-back",on:{"click":_vm.toBack}},[_c('img',{attrs:{"src":require("../../static/images/zuo.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }